
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../../apiservice/apis";

export const fetchPurchaseOrderRecord = createAsyncThunk(
  "purchaseOrderRecord/fetch",
  async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
    try {
      let url = "/purchase/get-purchase-order-record";
      if (selectedRecordType === "with item") {
        url = "/purchase/get-purchase-order-record-with-details";
      }
      if (
        selectedFilterType &&
        ["By Item", "By Tag", "By Group", "By Category"].includes(selectedFilterType)
      ) {
        url = "/purchase/get-purchase-order-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        selectedRecordType: selectedRecordType || null,
        locationId: selectedFilterType === "By Location" ? filters.locationId || null : null,
        supplierId: selectedFilterType === "By Supplier" ? filters.supplierId || null : null,
        employeeId: selectedFilterType === "By Employee" ? filters.employeeId || null : null,
        itemId: selectedFilterType === "By Item" ? filters.itemId || null : null,
        groupId: selectedFilterType === "By Group" ? filters.groupId || null : null,
        categoryId: selectedFilterType === "By Category" ? filters.categoryId || null : null,
        userId: selectedFilterType === "By User" ? filters.userId || null : null,
        serialNumber: selectedFilterType === "By Item Serial" ? filters.serialNumber || "" : "",
        tag_groupnameid: selectedFilterType === "By Tag" ? filters.tag_groupnameid || null : null,
        tagFeildNameid: selectedFilterType === "By Tag" ? filters.tagFeildNameid || null : null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };


      const res = await postData(url, payload);

      let mapped = [];
      if (selectedRecordType === "with item") {
        mapped = res.data.flatMap((purchaseOrder) =>
          purchaseOrder.details.map((item, idx) => ({
            id: `${purchaseOrder.pur_o_id}-${item.item_id}-${idx}`,
            row_id: purchaseOrder.pur_o_id,
            vch_no: purchaseOrder.pur_order_no,
            date: purchaseOrder.created_date,
            supplier: purchaseOrder.acc_name,
            employee: purchaseOrder.employee_name,
            createdBy: purchaseOrder.full_name,
            mode: purchaseOrder.trans?.map((t) => t.to_acc_name).join(", ") || "",
            item: item.item_name,
            rate: Number(item.item_rate || 0).toFixed(2),
            discount: item.item_discount_per ? `${item.item_discount_per}%` : "",
            vat: item.item_tax_per ? `${item.item_tax_per}%` : "",
            qty: `${item.item_qty} ${item.unit_name || ""}`,
            total: Number(item.item_total || 0).toFixed(2),

            // Keep raw values for grand totals
            masterQty: Number(item.item_qty || 0),
            baseQty: Number(item.retail_qty || 0),

            unitDetails: `Total : Master U. Qty = ${item.item_qty || 0}, Base U. Qty = ${item.retail_qty || 0}`,

            remainingQty: Number(item.remaining_item_qty || 0),
            status: purchaseOrder.status === "c" ? "Approved" : "Pending",
            // Separate from the "status" mapping above (which means
            // open/fully-received, not approval state) — see approval_status
            // on purchase_order_master, set by the multi-stage approval workflow.
            approval_status: purchaseOrder.approval_status || "none",
            is_locked: item?.is_locked
          }))
        );
      } else {
        // Normal summary view
        mapped = res.data.map((row) => ({
          id: row.pur_o_id,
          vch_no: row.pur_order_no,
          date: row.created_date,
          supplier: row.acc_name,
          createdBy: row.full_name,
          employee: row.employee_name,
          mode: row.trans?.map((t) => t.to_acc_name).join(", ") || "",
          subtotal: Number(row.sub_total || 0).toFixed(2),
          discount: Number(row.total_discount || 0).toFixed(2),
          vat: Number(row.total_tax || 0).toFixed(2),
          service: Number(row.other_service_cost || 0).toFixed(2),
          total: Number(row.total_amount || 0).toFixed(2),
          paid: Number(row.paid_total || 0).toFixed(2),
          due: Number(row.due_total || 0).toFixed(2),
          status: row.status === "c" ? "Approved" : "Pending",
          // Separate from the "status" mapping above (which means
          // open/fully-received, not approval state) — see approval_status
          // on purchase_order_master, set by the multi-stage approval workflow.
          approval_status: row.approval_status || "none",
          is_locked: row?.is_locked
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const deletePurchaseOrder = createAsyncThunk(
  "purchaseOrderRecord/delete",
  async (purOrderId, { rejectWithValue }) => {
    try {
      const res = await postData("/order/purchase-order-delete", {
        pur_o_id: purOrderId,
      });

      if (res?.error) return rejectWithValue(res.error);
      return purOrderId; // for optimistic update
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);


